import { render, staticRenderFns } from "./ProductContextMenu.vue?vue&type=template&id=2f43192f&scoped=true"
import script from "./ProductContextMenu.vue?vue&type=script&lang=js"
export * from "./ProductContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ProductContextMenu.vue?vue&type=style&index=0&id=2f43192f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43192f",
  null
  
)

export default component.exports